



















import { Component, Mixins } from 'vue-property-decorator'

import AppSection2 from '@/components/AppSection2.vue'
import AppSectionMore from '@/components/AppSectionMore.vue'
import TabBarShopping from '@/components/TabBarShopping.vue'
import { VIEW_SECTION_CONNECTION } from '@/gql/shopping'
import { Common, ScrollToFetch } from '@/mixins'

@Component({
  components: {
    AppSection2,
    AppSectionMore,
    TabBarShopping
  },
  apollo: {
    viewSectionConnection: {
      query: VIEW_SECTION_CONNECTION,
      variables () {
        return {
          screenType: 'CATEGORY'
        }
      }
    }
  }
})
export default class extends Mixins(Common, ScrollToFetch) {
  viewSectionConnection = { viewSections: [] }
  mounted () {
    this.addScrollListener('viewSectionConnection', 'viewSections')
  }
}
